import script from "./EditTextOverlay.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditTextOverlay.vue?vue&type=script&setup=true&lang=ts"

import "./EditTextOverlay.vue?vue&type=style&index=0&id=d5e97f1c&lang=scss"

const __exports__ = script;

export default __exports__